import { render, staticRenderFns } from "./promoterDetail.vue?vue&type=template&id=a3d1da8a&scoped=true&"
import script from "./promoterDetail.vue?vue&type=script&lang=js&"
export * from "./promoterDetail.vue?vue&type=script&lang=js&"
import style0 from "./promoterDetail.vue?vue&type=style&index=0&id=a3d1da8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d1da8a",
  null
  
)

export default component.exports